import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { channelIdentifiersService } from '@/services/channel-identifiers.service';
import { selectedAccountIdAtom } from '@/hooks/use-account';

/**
 * The picker feed, read live from each connected helpdesk, so it is slower and more
 * fragile than anything served from our own database.
 *
 * There is no companion query for mapped destinations: a destination lives on its inbox's
 * channel row, so `useInboxes` already carries it. Creating an inbox is what changes this
 * list, and use-inboxes invalidates it.
 */
const availableIdentifiersQueryAtom = atomWithQuery((get) => {
  const id = get(selectedAccountIdAtom);
  return {
    queryKey: ['channel-identifiers-available', id],
    enabled: id != null,
    staleTime: 5 * 60 * 1000,
    queryFn: () => channelIdentifiersService.available(id as number)
  };
});

export const useAvailableIdentifiers = () => {
  const [result] = useAtom(availableIdentifiersQueryAtom);
  return result;
};
